import SvgIcon from '@mui/material/SvgIcon';

export default function ShareIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7a2.99 2.99 0 0 0 0-1.39l7.05-4.11A2.99 2.99 0 1 0 15 5a2.99 2.99 0 0 0 .04.49L8 9.6a3 3 0 1 0 0 4.8l7.05 4.11c-.03.16-.05.32-.05.49a3 3 0 1 0 3-2.92z" />
    </SvgIcon>
  );
}
